

const mobilityOnDemand = () => import(/* webpackChunkName: "mobility router view" */ "../../views/mobilityOnDemand/MobilityOnDemand");
const driversReport = () => import(/* webpackChunkName: "DriversReport.vue"*/ "../../views/mobilityOnDemand/drivers/DriversReport.vue");
const ridesMobility = () => import(/* webpackChunkName: "RidesMobility.vue" */ "../../views/mobilityOnDemand/ridesMobility/RidesMobility.vue");
const drivers = () => import(/* webpackChunkName "Drivers.vue"*/ "../../views/mobilityOnDemand/drivers/Drivers.vue");
const EditDriver = () => import(/* webpackChunkName "EditDriver.vue"*/ "@/views/mobilityOnDemand/drivers/EditDriver.vue");
const vehicles = () => import(/* webpackChunkName "Vehicles.vue"*/ "../../views/mobilityOnDemand/drivers/Vehicles.vue");
const NewVehicle = () => import(/* webpackChunkName: "User New" */ "@/views/mobilityOnDemand/drivers/NewVehicle.vue");



const mobilityRoutes = [{
  path: "mobilityOnDemand",
  name: "Mobility On Demand",
  redirect: {
    name: "Drivers Report"
  },
  component: mobilityOnDemand,
  children: [{
      path: "driversReport",
      name: "Drivers Report",
      component: driversReport
    },
    {
      path: "ridesMobility",
      name: "Rides Mobility",
      component: ridesMobility
    },
    {
      path: "drivers",
      name: "Drivers Mobility",
      component: drivers
    },
    {
      path: 'edit/:controlNumber',
      name: 'Driver Edit',
      component: EditDriver,
      props: true
    },
  
    {
      path: "vehicles",
      name: "Vehicles Mobility",
      component: vehicles
    },
    {
      path:"new",
      name:"Vehicle New",
      component: NewVehicle
    },
    {
      path: 'editVehicle/:idCar',
      name: 'Vehicle Edit',
      component: NewVehicle,
      props: true
    }
  ]
}];

export default mobilityRoutes;
